import flatpickr from "flatpickr"
import flatpickrLocale from "flatpickr/dist/l10n/ko.js"
flatpickr.localize(flatpickrLocale.ko);

// vendor css
import "flatpickr/dist/flatpickr.css";
import "choices.js/public/assets/styles/choices.css";
import "@tabler/icons-webfont/dist/tabler-icons.css";
import "swiper/css";
// import "dropzone/dist/basic.css";
// import "dropzone/dist/dropzone.css";

// 필요 scss
import "../scss/common/plugins/editor.scss";
import "../scss/common/plugins/dropzone.scss";

// common js (사용자 사이트에서 기본적으로 로드하는 것만)
import "./plugins/popup.js";
import "./plugins/ui-notify.js";
import "./plugins/delete.js";